import React, { useState } from "react";
import { useFormikContext } from "formik";
import { TFormValues } from "../../types";

import { GuideContext } from "../../../../components/GatewayForm/GatewayForm.store";

const GuidedDetailsStep: React.FC<{}> = () => {
  const { setCurrentStep } = React.useContext(GuideContext);
  const { values } = useFormikContext<TFormValues>();
  const [topics, setTopics] = useState([
    { title: "This is a title", description: "description", value: "1" },
    { title: "This is a title", description: "description", value: "2" },
  ]);
  return (
    <div>
      <div>
        <h1>Mining & Coal Seam Gas</h1>
        <div>
          <div>Updated June 2021</div>
          <div>Reading time: 8 min</div>
        </div>
        <div>
          <button>Read the factsheet</button>
        </div>
      </div>
      <div>
        <h4>Key takeaways</h4>
        <ul>
          <li>Key</li>
          <li>Takeaway</li>
        </ul>
      </div>
      <div>
        <h4>This resource appears in:</h4>
        <div>
          <a href="#">Mining</a>, <a href="#">fracking</a> and{" "}
          <a href="#">fossil fuels</a>
        </div>
      </div>
      <div>
        <h4>Learn more about this topic</h4>
        {topics.map((doc) => {
          return <button onClick={() => {}}>{doc.title}</button>;
        })}
      </div>
      <div>Didn’t find the help you’re looking for?</div>
      <div>
        <button
          onClick={() => {
            setCurrentStep("eligible-step-two");
          }}
        >
          Apply for legal advice
        </button>
      </div>
    </div>
  );
};
export default GuidedDetailsStep;
